import { Component } from '@angular/core';

@Component({
    selector: 'app-session-unfreeze-confirmation',
    templateUrl: './session-unfreeze-confirmation.component.html',
    styleUrls: ['./session-unfreeze-confirmation.component.scss'],
    standalone: false
})
export class SessionUnfreezeConfirmationComponent {
  
}
